import React, { useContext, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { isEmpty } from "../utils/Utils";
import DeleteCard from "./DeleteCard";
import { UidContext } from "../../Components/App.Context";
import moment from "moment";
import "moment/locale/fr";
import {
  addKnwoledgeFav,
  getKnwoledgeFav,
  removeKnowledgeFav,
} from "../../actions/knowledgeFav.actions";
import parse from "html-react-parser";
import { Bookmark } from "lucide-react";

const extractIframeTag = (content) => {
  if (!content) {
    return { iframeTag: null, hasIframe: false };
  }

  const iframeRegex = /<iframe\b[^>]*>([\s\S]*?)<\/iframe>/;
  const match = content.match(iframeRegex);
  if (match) {
    const iframeTag = match[0];
    const cleanedIframeTag = iframeTag.replace(
      /style="[^"]*position:\s*absolute;?[^"]*"/,
      'style="width: 100%; height: 100%;"'
    );
    return { iframeTag: cleanedIframeTag, hasIframe: true };
  }
  return { iframeTag: null, hasIframe: false };
};

const Card = ({ post }) => {
  const [isLoading, setIsLoading] = useState(true);
  const [isAdmin, setIsAdmin] = useState(false);
  const [isFavorite, setIsFavorite] = useState(false);
  const userData = useSelector((state) => state.userReducer);
  const uid = useContext(UidContext);
  const dispatch = useDispatch();

  const knowledgeFav = useSelector((state) => state.knowledgeFav);

  useEffect(() => {
    !isEmpty(post) && setIsLoading(false);
  }, [post]);

  useEffect(() => {
    if (uid === userData?.id && userData?.isAdmin && !isAdmin) {
      setIsAdmin(true);
    }
  }, [isAdmin, uid, userData]);

  const formattedDate = moment(post?.createdAt).locale("fr").format("MMM YYYY");

  useEffect(() => {
    const myFavorite = Object.values(knowledgeFav).find(
      (fav) => fav?.userId === userData.id && fav?.knowledgeId === post?.id
    );
    myFavorite && setIsFavorite(true);
  }, [knowledgeFav, userData]);

  const handleAddFavorite = (e) => {
    e.preventDefault();
    const newIsFavorite = !isFavorite;

    dispatch(
      isFavorite
        ? removeKnowledgeFav(userData?.id, post?.id)
        : addKnwoledgeFav(userData?.id, post?.id)
    ).then(() => {
      dispatch(getKnwoledgeFav(userData?.id));
      setIsFavorite(newIsFavorite);
    });
  };

  const { iframeTag, hasIframe } = extractIframeTag(post?.texte);

  const canDelete = isAdmin || userData.id === post?.user?.id;

  return (
    <div className="tuto-card">
      {isLoading ? (
        <div className="tuto-card-loading">
          <span className="tuto-spinner" />
        </div>
      ) : (
        <>
          <div className="tuto-card-preview">
            <Link to={`/tutoriels/${post?.id}`} className="tuto-card-preview-link">
              {hasIframe && typeof iframeTag === "string" ? (
                parse(iframeTag)
              ) : (
                <div className="tuto-card-cover">
                  <span>{post?.title}</span>
                </div>
              )}
            </Link>
            <div className="tuto-card-actions">
              {canDelete && (
                <div className="tuto-action-btn danger" title="Supprimer">
                  <DeleteCard id={post.id} />
                </div>
              )}
              <button
                className={`tuto-action-btn fav ${isFavorite ? "active" : ""}`}
                onClick={handleAddFavorite}
                title={isFavorite ? "Retirer des favoris" : "Ajouter aux favoris"}
              >
                <Bookmark size={16} fill={isFavorite ? "currentColor" : "none"} />
              </button>
            </div>
          </div>

          <Link to={`/tutoriels/${post?.id}`} className="tuto-card-body">
            <span className="tuto-card-date">{formattedDate}</span>
            <p className="tuto-card-title">{post?.title}</p>
            <span className="tuto-card-author">
              {post?.user?.firstname} {post?.user?.name}
            </span>
            {post?.categories ? (
              <span className="tuto-card-cat">{post.categories}</span>
            ) : null}
          </Link>
        </>
      )}
    </div>
  );
};

export default Card;
